import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

import { useCallback, useMemo } from 'react';
import styled from '@xstyled/styled-components';
import { AudioPlayer, styleVariables, EditorCommentViewOnly, EditorComment, getColor, getSize } from '@lib/common';
import { Space } from 'antd';
import { BaseQuestionGradingComponent } from '../../../bases';
import { InfoCircleOutlined, HighlightOutlined } from '@ant-design/icons';
import { EmptyAnswerLabel, countWords } from './components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledSpaceContainer = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StyledAudioPlayerContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), getSize('gap8'));
var StyledEditorSection = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  padding-top: ", ";\n  border-top: 1px solid ", ";\n"])), getSize('gap16'), getSize('gap16'), getColor('fillBgBlack'));
var StyledStudentWorkHeader = styled(Space)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n"])));
var StyledSectionLabel = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  margin-right: ", ";\n"])), getSize('typo16'), styleVariables.font.fontWeightStrong, getSize('gap4'));
var StyledAnswerContainer = styled(Space)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StyledHighlightGuideBox = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  margin-bottom: ", ";\n"])), getColor('fillIconBgDefault'), getSize('gap8'), getSize('padding8'), getSize('gap16'));
var StyledHighlightGuideHeaderRow = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var StyledHighlightGuideTitleGroup = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"])));
var StyledHighlightGuideTitleText = styled.span(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n"])), getSize('typo14'), styleVariables.font.fontWeightStrong, getColor('textIntDefault'));
var StyledHighlightGuideStepList = styled.ol(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  margin: ", " 0 0 0;\n  padding-left: ", ";\n  font-size: ", ";\n  color: ", ";\n"])), getSize('gap8'), getSize('gap24'), getSize('typo14'), getColor('textIntDefault'));
var StyledHighlightGuideStep = styled.li(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), getSize('gap4'));
export var EssayGradingComponent = function EssayGradingComponent(_ref) {
  var _answer$value6;

  var states = _ref.states,
      actions = _ref.actions;
  var baseLabel = states.label,
      answer = states.answer,
      comments = states.comments,
      setComments = states.setComments,
      disabled = states.disabled,
      loadingComment = states.loadingComment;
  var label = baseLabel;
  var onAnswerComment = actions.onAnswerComment,
      onUpdateAnswerComment = actions.onUpdateAnswerComment,
      onDeleteAnswerComment = actions.onDeleteAnswerComment,
      onClickAnswer = actions.onClickAnswer;
  var shouldShowHighlightGuide = useMemo(function () {
    var _answer$value;

    return !!(onAnswerComment && onUpdateAnswerComment && onDeleteAnswerComment && setComments) && !(answer !== null && answer !== void 0 && answer.isEmpty() || !(answer !== null && answer !== void 0 && (_answer$value = answer.value) !== null && _answer$value !== void 0 && _answer$value.text)) && !!label.highlightGuideTitle;
  }, [onAnswerComment, onUpdateAnswerComment, onDeleteAnswerComment, setComments, answer, label.highlightGuideTitle]);
  var editorCommentLabels = useMemo(function () {
    return {
      save: label.save,
      cancel: label.cancel,
      comment: label.comment,
      selectColor: label.selectColor
    };
  }, [label.save, label.cancel, label.comment, label.selectColor]);
  var handleClickAnswer = useCallback(function () {
    if (onClickAnswer && answer !== null && answer !== void 0 && answer.id) {
      onClickAnswer(answer.id.toString());
    }
  }, [onClickAnswer, answer === null || answer === void 0 ? void 0 : answer.id]);

  var renderAnswer = function renderAnswer() {
    var _answer$answerComment, _answer$value2, _answer$answerComment2, _answer$answerComment3, _answer$answerComment4, _answer$answerComment5, _answer$value4, _answer$value5;

    if (answer !== null && answer !== void 0 && answer.isEmpty()) {
      return /*#__PURE__*/_jsx(EmptyAnswerLabel, {
        children: "[".concat(label.noAnswer, "]")
      });
    }

    var answerContent = (answer === null || answer === void 0 ? void 0 : (_answer$answerComment = answer.answerComment) === null || _answer$answerComment === void 0 ? void 0 : _answer$answerComment.submissionAnswerContent) || (answer === null || answer === void 0 ? void 0 : (_answer$value2 = answer.value) === null || _answer$value2 === void 0 ? void 0 : _answer$value2.text);

    if (shouldShowHighlightGuide) {
      var _answer$value3;

      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(StyledAnswerContainer, {
          direction: "vertical",
          onClick: handleClickAnswer,
          children: /*#__PURE__*/_jsx(EditorComment, {
            onAnswerComment: onAnswerComment,
            content: answerContent,
            onUpdateAnswerComment: onUpdateAnswerComment,
            onDeleteAnswerComment: onDeleteAnswerComment,
            showComment: true,
            comments: comments,
            setComments: setComments,
            labels: editorCommentLabels,
            loadingComment: loadingComment
          })
        }), (answer === null || answer === void 0 ? void 0 : (_answer$value3 = answer.value) === null || _answer$value3 === void 0 ? void 0 : _answer$value3.audioFile) && /*#__PURE__*/_jsx(AudioPlayer, {
          source: answer.value.audioFile.url
        })]
      });
    }

    return /*#__PURE__*/_jsxs(StyledAnswerContainer, {
      direction: "vertical",
      children: [(answer === null || answer === void 0 ? void 0 : (_answer$answerComment2 = answer.answerComment) === null || _answer$answerComment2 === void 0 ? void 0 : _answer$answerComment2.submissionAnswerContent) && /*#__PURE__*/_jsx(StyledEditorSection, {
        children: /*#__PURE__*/_jsx(EditorCommentViewOnly, {
          content: answer.answerComment.submissionAnswerContent,
          comments: (answer === null || answer === void 0 ? void 0 : (_answer$answerComment3 = answer.answerComment) === null || _answer$answerComment3 === void 0 ? void 0 : (_answer$answerComment4 = _answer$answerComment3.comments) === null || _answer$answerComment4 === void 0 ? void 0 : _answer$answerComment4.map(function (comment) {
            return {
              id: comment.id.toString(),
              content: comment.content
            };
          })) || [],
          scrollable: true,
          labels: {
            comment: label.comment
          }
        })
      }), !(answer !== null && answer !== void 0 && (_answer$answerComment5 = answer.answerComment) !== null && _answer$answerComment5 !== void 0 && _answer$answerComment5.submissionAnswerContent) && (answer === null || answer === void 0 ? void 0 : (_answer$value4 = answer.value) === null || _answer$value4 === void 0 ? void 0 : _answer$value4.text) && /*#__PURE__*/_jsx(StyledEditorSection, {
        children: /*#__PURE__*/_jsx(EditorCommentViewOnly, {
          content: answer.value.text,
          comments: [],
          scrollable: true,
          labels: {
            comment: label.comment
          }
        })
      }), (answer === null || answer === void 0 ? void 0 : (_answer$value5 = answer.value) === null || _answer$value5 === void 0 ? void 0 : _answer$value5.audioFile) && /*#__PURE__*/_jsx(StyledAudioPlayerContainer, {
        children: /*#__PURE__*/_jsx(AudioPlayer, {
          source: answer.value.audioFile.url
        })
      })]
    });
  };

  var renderHighlightGuide = function renderHighlightGuide() {
    if (!shouldShowHighlightGuide) {
      return null;
    }

    return /*#__PURE__*/_jsxs(StyledHighlightGuideBox, {
      children: [/*#__PURE__*/_jsx(StyledHighlightGuideHeaderRow, {
        children: /*#__PURE__*/_jsxs(StyledHighlightGuideTitleGroup, {
          children: [/*#__PURE__*/_jsx(InfoCircleOutlined, {}), /*#__PURE__*/_jsx(HighlightOutlined, {}), /*#__PURE__*/_jsx(StyledHighlightGuideTitleText, {
            children: label.highlightGuideTitle
          })]
        })
      }), /*#__PURE__*/_jsxs(StyledHighlightGuideStepList, {
        children: [label.highlightGuideStep1 && /*#__PURE__*/_jsx(StyledHighlightGuideStep, {
          children: label.highlightGuideStep1
        }), label.highlightGuideStep2 && /*#__PURE__*/_jsx(StyledHighlightGuideStep, {
          children: label.highlightGuideStep2
        }), label.highlightGuideStep3 && /*#__PURE__*/_jsx(StyledHighlightGuideStep, {
          children: label.highlightGuideStep3
        })]
      })]
    });
  };

  var wordCount = answer !== null && answer !== void 0 && (_answer$value6 = answer.value) !== null && _answer$value6 !== void 0 && _answer$value6.text ? countWords(answer.value.text) : 0;
  return /*#__PURE__*/_jsx(BaseQuestionGradingComponent, {
    states: states,
    actions: actions,
    children: /*#__PURE__*/_jsxs(StyledSpaceContainer, {
      direction: "vertical",
      children: [renderHighlightGuide(), /*#__PURE__*/_jsxs(StyledStudentWorkHeader, {
        children: [/*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(StyledSectionLabel, {
            children: label.studentWork
          }), shouldShowHighlightGuide && /*#__PURE__*/_jsxs("i", {
            children: [/*#__PURE__*/_jsx(HighlightOutlined, {}), label.selectTextToHighlight]
          })]
        }), wordCount > 0 && /*#__PURE__*/_jsxs("span", {
          children: [wordCount, " ", label.word]
        })]
      }), renderAnswer()]
    })
  });
};